'use strict';
/**
 * @author Maxim Seredkin
 */

export default function projectMaintenanceTree() {
    return {
        restrict: 'A',
        template: require('../view/project-maintenance-tree.html'),
        scope: {
            selectedItem: '=myModel',
            items: '=myItems'
        },
        controller: ['$scope',
            function ($scope) {

                $scope.select = select;
                $scope.isSelect = isSelect;

                init();

                // region Function

                function init() {
                    $scope.isOpen = false;
                    $scope.filter = {};
                    $scope.columns = [{
                        data: 'activityName'
                    }];
                    $scope.items = buildTree($scope.items);

                }

                function buildTree(items) {
                    let tree = [];
                    if (Array.isArray(items)) {
                        tree = items.filter(item => item.parentIndex == null);
                        tree.forEach(item => {
                            addNodes(item, items);
                        });
                    }

                    return tree;
                }

                function addNodes(node, nodes) {
                    node.nodes = [];
                    if (Array.isArray(nodes)) {
                        nodes.forEach(item => {
                            if (item.parentIndex == node.index) {
                                node.nodes.push(item);
                                addNodes(item, nodes);
                            }
                        });
                    }
                }

                function select(item) {
                    $scope.selectedItem = item;
                }

                function isSelect(item) {
                    if ($scope.selectedItem) {
                        return $scope.selectedItem.index === item.index;
                    }
                    return $scope.selectedItem === item;
                }

                function update() {
                    $scope.$applyAsync(function () {
                        $scope.$broadcast("updateStateNode", null);
                    });
                }

                // endregion

                // region Watcher

                $scope.$watch('selectedItem', function () {
                    if ($scope.selectedItem != null) {
                        update();
                    }
                });

                // endregion

            }]
    };
}
